
enum PriceRecommendationStateDriverType {
	OCCUPANCY = "OCCUPANCY", MARKET = "MARKET", COMPETITORS = "COMPETITORS"
}

export default PriceRecommendationStateDriverType;